<frog-landing-toolbar></frog-landing-toolbar>
<div class="root">
    <div class="flex row odd">
        <div class="flex column">
            <div class="flex row align-center justify-center feature-block">
                <div>
                    <h4></h4>
                    <h1>Privacy Policy</h1>
                    <h4>Last updated September 2, 2022</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="middle flex justify-center">
        <div class="flex-80">
            <!-- BEGIN Privacy Policy -->
            <p>
                FrogUBD, LLC (“<strong>FrogEye</strong>,” “<strong>we</strong>,”
                “<strong>our</strong>” or “<strong>us</strong>”) respects your privacy and is
                committed to protecting it through our compliance with this privacy policy. This
                privacy policy explains our policies and procedures regarding the collection, use,
                disclosure, and security of certain information that we receive, with a focus on
                information that would be considered “personal information,” including information
                by which you may be personally identified. It is our sincere hope that by explaining
                our practices for handling information, we will develop a trusting and long-lasting
                relationship with you.
            </p>
            <p>
                FrogEye provides certain services through, or that are enabled by, frogeye.io (the
                “<strong>Website</strong>”), including a SaaS-based platform for sharing creative
                assets across teams and partners (each such service, a “<strong>Service</strong>”)
                individuals and entities (“<strong>you</strong>”).
            </p>
            <p>
                Please note that by accessing and using the Site or Services, you are accepting the
                practices described in this privacy policy. This privacy policy is incorporated by
                reference into the <a href="/terms">Terms of Service</a> that govern your access and
                use of the Services and the Website (the “<strong>Terms of Service</strong>”).
            </p>
            <p>
                This policy describes the types of information we may collect from you or that you
                may provide when you access or use the Site or Services, and our practices for
                collecting, using, maintaining, protecting and disclosing that information. This
                policy applies to information we collect or may collect:
            </p>
            <ul>
                <li>through your accessing and using the Website.</li>
                <li>
                    through your registering and creating an account to access and use the Services
                    and the FrogEye Website.
                </li>
                <li>through your accessing and using the Services.</li>
                <li>
                    in email, text and other electronic messages sent to or from you through or in
                    connection with the Website or the Services.
                </li>
                <li>when you send any content through the Website or any of the Services.</li>
                <li>
                    through services provided to us or to you by third-party companies, agents or
                    contractors, including our partners.
                </li>
            </ul>
            <p>It does not apply to information collected by:</p>
            <ul>
                <li>
                    us offline or through any other means, including on any other website operated
                    by FrogEye or any third party; or
                </li>
                <li>
                    any third party, including through any link that may be accessible from or on
                    the Website or any of the Services.
                </li>
            </ul>
            <p>
                Please read this policy carefully to understand our policies and practices regarding
                your information and how we will treat it. If you do not agree with our policies and
                practices, your only choice is not to access or use the Services, the Website or any
                of the Services. By accessing or using the Services or any of the Services, you
                agree to this privacy policy. This policy may change from time to time as described
                in the provision of this privacy policy titled “Changes to Our Privacy Policy”
                below.
            </p>
            <h2>Minors Under the Age of 18</h2>
            <p>
                Neither the Website nor any of the Services are intended for minors under 18 years
                of age. No one under age 18 may provide any information on or through the Website or
                the Services. We do not knowingly collect personal information from children under
                18. If you are under 18, do not use or provide any information on or through any of
                the Services or any of its features or register on the Website, use any of the
                interactive or public comment features of any of the Services or provide any
                information about yourself to us, including your name, address, telephone number,
                email address or any screen name, username you may use or any pictures of you. If we
                learn we have collected or received personal information from a child under 18
                without verification of parental consent, we will delete that information. If you
                believe that we might have any information from or about a child under 18, please
                contact us at <a href="mailto:privacy@frogeye.io">privacy&#64;frogeye.io</a>.
            </p>
            <h2>Information We Collect About You and How We Collect It</h2>
            <p>
                We collect, or may collect, several types of information from and about users who
                access or use the Website or the Services, including:
            </p>
            <ul>
                <li>
                    information by which you may be personally identified, including personal
                    information such as name, a user name, birthdate, gender at birth, email
                    address, address and phone number;
                </li>
                <li>analytics information;</li>
                <li>
                    information that is about you but individually does not identify you, such as
                    the date and time of visit;
                </li>
                <li>
                    device, internet and mobile information such as the hardware model, operating
                    system version, unique device identifiers, browser type, language, wireless
                    network, and mobile network information;
                </li>
                <li>geolocation information;</li>
                <li>
                    troubleshooting or diagnostic information provided when you report a problem or
                    concern with the Services, the Website or any of the Services;
                </li>
                <li>
                    records and copies of your correspondence (including email addresses), if you
                    contact us; and/or
                </li>
                <li>
                    details of transactions you carry out through the Website or any of the
                    Services.
                </li>
            </ul>
            <p>We collect this information:</p>
            <ul>
                <li>directly from you when you provide it to us.</li>
                <li>
                    automatically as you navigate through or use the Website or any of the Services.
                </li>
                <li>
                    from third parties, such as our customers, business partners and other third
                    parties that provide us or you with certain services.
                </li>
            </ul>
            <p>
                Certain situations may also involve you calling us or our calling you. Please be
                aware that we may monitor, and in some cases, record such calls for staff training
                or quality assurance purposes.
            </p>
            <h2>Data Minimization</h2>
            <p>
                We take every reasonable step to limit the volume of your personal information that
                we process to what is reasonably necessary.
            </p>
            <h2>Consequences of Not Providing Personal information</h2>
            <p>
                If you do not provide certain personal information identified in this policy, we may
                not be able to provide you access or use of the Services or the support that we
                otherwise could if you did provide this personal information.
            </p>
            <h2>Use of Cookies and Other Tracking Technologies</h2>
            <p>
                We use cookies and similar tracking technologies to track the activity on our
                Service and we hold certain information. Cookies are files with a small amount of
                data which may include an anonymous unique identifier. Cookies are sent to your
                browser from a website and stored on your device. Other tracking technologies are
                also used such as beacons, tags and scripts to collect and track information and to
                improve and analyze our Service.
            </p>
            <p>
                You can instruct your browser to refuse all cookies or to indicate when a cookie is
                being sent. However, if you do not accept cookies, you may not be able to use some
                portions of our Service.
            </p>
            <p>Examples of cookies we use:</p>
            <ul>
                <li>Session Cookies: We use session cookies to operate our Service.</li>
                <li>
                    Preference Cookies: We use preference cookies to remember your preferences and
                    various settings.
                </li>
                <li>Security Cookies: We use security cookies for security purposes.</li>
            </ul>
            <h2>Do Not Track Policy</h2>
            <p>
                Your web browser may offer you a “Do Not Track” option, which allows you to signal
                to operators of websites, web applications and services (including behavioral
                advertising services) that you do not wish these operators to track certain of your
                online activities over time and across different websites. We do not honor any web
                browser “Do Not Track” signals or other mechanisms that provide you with the ability
                to exercise choice regarding the collection of personally identifiable information
                about your online activities over time and across third-party websites or online
                services. At present, no universally accepted standards exist on how companies
                should respond to do-not-track signals. In the event a final universally accepted
                standard is established, we will assess and provide an appropriate response to these
                signals.
            </p>
            <h2>Third-party Responsibilities and Services</h2>
            <p>
                We may use or partner with other companies, agents or contractors for various
                purposes in connection with our business and operations (“<strong
                    >Service Providers</strong
                >”), including for the marketing and growth of our business and the performance of
                services on our behalf, such as signing you into your FrogEye account, processing
                your payments, gathering and analyzing information, and the provision of services to
                you. In the course of performing these responsibilities and providing such services,
                these other companies may have access to your information. We may also share
                information, including your information, with these Service Providers to enable them
                to perform these responsibilities and to provide these services. These Service
                Providers may have adopted their own privacy policies, which are not subject to
                control by FrogEye. You should always review the policies of these Service Providers
                to make sure that you are comfortable with the ways in which they collect, use,
                maintain, protect and disclose your information.
            </p>
            <p>
                As a convenience to you, we also provide links to third parties from the Website or
                within our Services. If you click on one of these links, you will be redirected to
                that third-party’s Website (via affiliate cookies) and such third party may also
                transmit cookies to you. We do not have any control over that transmission, or how
                they collect, use, maintain, protect and disclose your information. Please be aware
                that cookies placed by third parties may continue to track your activities online
                even after you are no longer using any of the Services, and those third parties may
                not honor “Do Not Track” requests you have set using your web browser.
            </p>
            <h2>Google Analytics</h2>
            <p>
                We may now or in the future use a tool called “Google Analytics” to collect
                information about use of the Website. Google Analytics collects information such as
                how often users visit the Website, what pages they visit when they do so, and what
                other Websites they used prior to coming to the Website. We use the information we
                get from Google Analytics to improve the Services, the Website, the Services and
                their related features, functionality and performance. Google Analytics collects
                only the IP address assigned to you on the date you visit this Website, rather than
                your name or other identifying information. We do not combine the information
                collected through the use of Google Analytics with personally identifiable
                information. Although Google Analytics plants a permanent cookie on your web browser
                to identify you as a unique user the next time you visit the Website, the cookie
                cannot be used by anyone but Google. Google’s ability to use and share information
                collected by Google Analytics about your visits to this Website is restricted by the
                Google Analytics Terms of Use and the Google Privacy Policy. You can prevent Google
                Analytics from recognizing you on return visits to the Website by disabling cookies
                on your browser.
            </p>
            <p>
                You can set preferences for how Google advertises to you using the Google Ad
                Preferences page, and if you want to, you can opt out of interest-based advertising
                entirely by cookie settings or permanently using a browser plugin.
            </p>
            <p>
                We may use Google Analytics and Google AdWords remarketing codes to log when users
                view specific pages or take specific actions on a website. This allows us to provide
                targeted advertising in the future. If you do not wish to receive this type of
                advertising from us in the future you can opt out using the DoubleClick opt-out page
                or the Network Advertising Initiative opt-out page.
            </p>
            <p>
                Google has additional information available about its Remarketing Privacy
                Guidelines, Policies, and Restrictions on its website.
            </p>
            <h2>How We Use Your Information</h2>
            <p>
                We will only use information that we collect about you or that you provide to us,
                including any personal information for purposes described in this privacy policy and
                when applicable law allows us to do so. We will generally use your information on
                the following legal grounds:
            </p>
            <ul>
                <li>where the use of your information is necessary to provide the Services;</li>
                <li>
                    where the use is necessary for the purposes of our legitimate interests (or
                    those of a third party);
                </li>
                <li>where we need to comply with a legal or regulatory obligation; or</li>
                <li>where you have given your consent (which can be withdrawn at any time).</li>
            </ul>
            <p>
                We use information that we collect about you or that you provide to us, including
                any personal information:
            </p>
            <ul>
                <li>to provide you the Services.</li>
                <li>to provide you the Website, the Services and the content they contain.</li>
                <li>to provide technical and other support to you.</li>
                <li>
                    to send you news or information about us or the Services that may be of interest
                    to you (if you have not opted out).
                </li>
                <li>
                    to enable Service Providers to perform certain responsibilities and provide
                    certain services in connection with the Services and our business and
                    operations.
                </li>
                <li>to fulfill any other purpose for which you provide it.</li>
                <li>to provide you with notices about the Services.</li>
                <li>
                    to carry out our obligations and enforce our rights arising from any contracts
                    entered into between you and us, including for billing and collection.
                </li>
                <li>to notify you about changes to any of the Services or the Website.</li>
                <li>to enhance the safety and security of the Services.</li>
                <li>
                    to verify your identity and prevent fraud or other unauthorized or illegal
                    activity.
                </li>
                <li>in any other way we may describe when you provide the information.</li>
                <li>for any other purpose with your consent.</li>
            </ul>
            <p>
                Some of the information that we collect automatically may be statistical data and
                does not include personal information, but we may maintain it or associate it with
                personal information we collect in other ways or receive from third parties, or that
                you provide to us. It helps us to improve the Website and the Services, and to
                deliver a better and more personalized service, including enabling us to:
            </p>
            <ul>
                <li>estimate our audience size and better understand usage patterns.</li>
                <li>recognize you when you return to the Website or a Service.</li>
            </ul>
            <h2>Disclosure of Your Information</h2>
            <p>
                We may disclose personal information that we collect or you provide as described in
                this privacy policy:
            </p>
            <ul>
                <li>to our subsidiaries and affiliates.</li>
                <li>
                    to users of the Services, in the case of information you opt to publish or to
                    share with such users.
                </li>
                <li>
                    to Service Providers, contractors and other third parties we use to support the
                    Services, and our business but only to the extent necessary for them to provide
                    this support.
                </li>
                <li>
                    to a potential or actual buyer, assignee or other successor (including its
                    related advisors and agents) in the event of a merger, divestiture,
                    restructuring, reorganization, dissolution or other sale or transfer of some or
                    all of FrogEye’s assets, whether as a going concern or as part of bankruptcy,
                    liquidation or similar proceeding, in which personal information held by FrogEye
                    about users of the Website and the Services is among the assets that may be or
                    are actually transferred.
                </li>
                <li>to fulfill the purpose for which you provide it.</li>
                <li>for any other purpose disclosed by us when you provide the information.</li>
                <li>with your consent.</li>
            </ul>
            <p>We may also disclose your information:</p>
            <ul>
                <li>
                    to comply with any court order, law or legal process, including to respond to
                    any government or regulatory request.
                </li>
                <li>
                    to enforce or apply the Terms of Service and other agreements, including for
                    billing and collection purposes.
                </li>
                <li>
                    if we believe disclosure is necessary or appropriate to protect the rights,
                    property, or safety of FrogEye, our customers or others.
                </li>
            </ul>
            <h2>Anonymized or Aggregated Information</h2>
            <p>
                We may create and/or receive information that is anonymized or in an aggregated form
                (that does not include any personal information about you). We may use and share any
                such information for any purpose without restriction so long as it does not violate
                the terms of this privacy policy, or any applicable law.
            </p>
            <h2>Choices About How We Use and Disclose Your Personal information</h2>
            <p>
                We strive to provide you with choices regarding the personal information you provide
                to us. We have created mechanisms to provide you with the following control over
                your personal information:
            </p>
            <ul>
                <li>
                    Tracking Technologies and Advertising. You can set your browser to refuse all or
                    some browser cookies, or to alert you when cookies are being sent.
                </li>
                <li>
                    Promotional Offers from FrogEye. If you do not wish to have your email
                    address/contact information used by FrogEye to market or otherwise promote our
                    own or third parties’ products or services, you can opt-out through the
                    unsubscribe mechanism at the bottom of the applicable email. This opt-out does
                    not apply to information provided to FrogEye as a result of a service or product
                    purchase, product service experience or other transactions.
                </li>
            </ul>
            <p>
                We do not control third parties’ collection or use of your information to serve
                interest-based advertising. You may be able to opt out of receiving personalized
                advertisements from companies who are members of the Network Advertising Initiative
                or who subscribe to the Digital Advertising Alliance’s Self-Regulatory Principles
                for Online Behavioral Advertising. For more information about this practice and to
                understand your options, please visit:
                <a href="http://www.aboutads.info">http://www.aboutads.info</a> and
                <a href="http://www.networkadvertising.org/choices/"
                    >http://www.networkadvertising.org/choices/</a
                >. You may also use TRUSTe’s Preference Manager at
                <a href="http://preferences-mgr.truste.com">http://preferences-mgr.truste.com</a>.
            </p>
            <h2>Accessing and Correcting Your Personal information</h2>
            <p>
                You may change, correct or delete any personal information that you have provided to
                us through your account (if you have one) or by emailing us at
                <a href="mailto:privacy@frogeye.io">privacy&#64;frogeye.io</a>.
            </p>
            <h2>Your California Privacy Rights</h2>
            <p>
                California Civil Code Section § 1798.83 may permit users of the Website who are
                California residents to request certain information regarding our disclosure of
                personal information to third parties for their direct marketing purposes. To make
                such a request, please send an email to privacy&#64;frogeye.io, or write to us at:
                FrogUBD, LLC, Attn: [Privacy Request], 801 FM 1463 STE 200 #256, Katy, TX, 77494.
            </p>
            <h2>How Long We Store Your Personal information</h2>
            <p>
                We will only retain your personal information, in a form which permits us to
                identify you, for as long as necessary to fulfill the purposes we collected it for.
                We will retain and use your personal information as necessary to satisfy any legal,
                accounting or reporting requirements, to resolve disputes or to enforce our
                agreements and rights. Subject to the foregoing, we will delete your personal
                information upon your request. To dispose of personal information, we may anonymize
                it, delete it or take other appropriate steps. Data may persist in copies made for
                backup and business continuity purposes for additional time.
            </p>
            <h2>Information Security</h2>
            <p>
                We understand that the security of your personal information is important. We
                provide reasonable administrative, technical, and physical security controls to
                protect your personal information. However, despite our efforts, no security
                controls are 100% effective. FrogEye cannot ensure or warrant the security of your
                personal information. Any transmission of personal information is at your own risk.
                We are not responsible for circumvention of any privacy settings or security
                measures contained on the Website or the Services.
            </p>
            <h2>Changes to Our Privacy Policy</h2>
            <p>
                If we make material changes to how we treat our users’ personal information that are
                materially less protective than provided in this policy, we will use reasonable
                efforts to notify you by email to the email address specified in your account and/or
                through a notice on the home pages of the Website and to attempt to get your consent
                to the changes. The date the privacy policy was last updated is identified above.
                You are responsible for ensuring that we have an up-to-date active and deliverable
                email address for you, and for periodically visiting the Website and this privacy
                policy to check for any changes. Like our Terms of Service, of which this privacy
                policy is a part, your use, and/or continued use after our efforts to contact you,
                of the Services, the Website or any of the Services, means that you agree to be
                bound by such changes.
            </p>
            <h2>Survival</h2>
            <p>
                The policies indicated in this privacy policy will remain effective, even if the
                Terms of Service and the other agreements between us are terminated and you are no
                longer using the Website or any of the Services.
            </p>
            <h2>Contact Information</h2>
            <p>
                To ask questions or comment about this privacy policy and our privacy practices or
                need to reach us for any other reason, you may contact us by email at
                <a href="mailto:privacy@frogeye.io">privacy&#64;frogeye.io</a> or by mail at
                FrogUBD, LLC, Attn: [Privacy Request], 801 FM 1463 STE 200 #256, Katy, TX, 77494.
            </p>

            <!-- END TOS -->
        </div>
    </div>

    <frog-footer></frog-footer>
</div>
